import React from "react";
import BlogForm from "./BlogForm";

const EditBlog = () => {
  return (
    <>
      <BlogForm action="Edit" />
    </>
  );
};

export default EditBlog;

